import React, { FC } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { OriginalDocuments } from './OriginalDocuments/OriginalDocuments'
import { Scanbacks } from './Scanbacks/Scanbacks'
import { DocumentsProps } from './types'
import styles from './styles.module.scss'

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } }
})

export const Documents: FC<DocumentsProps> = ({ orderId, currentUserId }) => (
  <QueryClientProvider client={queryClient}>
    <div className={styles.documentsContainer}>
      <Scanbacks orderId={orderId} />
      <OriginalDocuments orderId={orderId} currentUserId={currentUserId} />
    </div>
  </QueryClientProvider>
)
